import styled from '@emotion/styled'
import { Box as BoxBase, BoxProps, Flex as FlexBase } from 'reflexbox'

export type BaseProps = Omit<
  React.JSX.IntrinsicElements['div'] & BoxProps,
  keyof React.ClassAttributes<unknown>
>

export const Box = styled(BoxBase)<BaseProps & { gap?: string }>`
  ${({ gap = 0 }) => gap && `gap: ${gap};`}
`

export const Flex = styled(FlexBase)<BaseProps & { gap?: string }>`
  ${({ gap = 0 }) => gap && `gap: ${gap};`}
`
